// extracted by mini-css-extract-plugin
export var active = "_9r-a";
export var activeIndicator = "_9r-8";
export var animate = "_9r-9";
export var disabled = "_9r-b";
export var fullWidth = "_9r-2";
export var lg = "_9r-7";
export var md = "_9r-6";
export var redoButtonTabGroup = "_9r-0";
export var sm = "_9r-5";
export var tabButton = "_9r-3";
export var tabButtonsContainer = "_9r-1";
export var xs = "_9r-4";